import Milestone from '@model/Milestone'

export interface JourneyChanged {
    patientJourneyMilestoneId: number
    slug: string
    milestoneId: number
    date: string
    editable: boolean
    type: string
    primaryPatientJourneyId: number
    patientJourneyId: number
    isActive: boolean
    oldJourneyId: number
    newJourneyId: number
    oldJourneySlug: string
    newJourneySlug: string
    uuid: string
}

class JourneyChangedMilestone extends Milestone {
    type: string
    slug: string
    newJourneySlug: string
    oldJourneySlug: string

    constructor(object: Partial<JourneyChanged>) {
        super(object)
        this.type = Milestone.Type.journeyChanged
        this.slug = object.slug || 'journey-changed'
        this.newJourneySlug = object.newJourneySlug as string
        this.oldJourneySlug = object.oldJourneySlug as string
    }
}

export default JourneyChangedMilestone
